import { render, staticRenderFns } from "./skills.vue?vue&type=template&id=a6438da0&scoped=true&lang=pug&"
import script from "./skills.vue?vue&type=script&lang=coffee&"
export * from "./skills.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6438da0",
  null
  
)

export default component.exports